/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';
import $ from 'jquery';
import { Modal, Button } from 'react-bootstrap';
import Parser from 'html-react-parser';
import CartForm from './CartForm';
import SavedItems from './SavedItems';
import {Loader} from '../../Helpers/Helpers';
import ReactPixel from 'react-facebook-pixel';
import {checkFramedSize} from '../../Helpers/Helpers';

const ajaxurl = Constants.URL.root+'/wp-admin/admin-ajax.php';
var whichClicked = '';

export default class AddToCart extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			addFav: null,
			lgShow: false,
			show: false,
			cartShow: false,
			showGlassPopup: false,
			favLoading: false,
			compare1Selection: 0,
			compare2Selection: 1,
			savedItems: [],
			cartLoading: false,
			cartContent: null
        }
	    this.addToCart = this.addToCart.bind(this);
	    this.quickSave = this.quickSave.bind(this);
	    this.addToFav = this.addToFav.bind(this);
	    this.lgClose = this.lgClose.bind(this);
	    this.lgHide = this.lgHide.bind(this);
	    this.handleChange1 = this.handleChange1.bind(this);
	    this.handleChange2 = this.handleChange2.bind(this);
	    this.manageView = this.manageView.bind(this);
		this.handleShow = this.handleShow.bind(this);
    	this.handleClose = this.handleClose.bind(this);
    	this.handleOkay = this.handleOkay.bind(this);
  	}

    lgClose = () => this.setState({ lgShow: false });
    lgHide = () => this.setState({ show: false });
    cartHide = () => this.setState({ cartShow: false });

	handleClose() {
		this.setState({ showGlassPopup: false });
	}

	handleShow() {
		this.setState({ showGlassPopup: true });
	}

	handleOkay() {
		this.handleClose();
		var glassID = 0;
		this.props.glasses.filter( ( glass ) =>
          	'Perspex Glass' === glass.getIn(['title', 'rendered'])
        ).map( ( glass ) =>
        	glassID = glass.get('id')
        )
        this.dispatchSelectGlass(glassID)

		var self = this;
		setTimeout(() => {
			switch (whichClicked) {
				case 'addToCart':
					self.addToCart(glassID)
					break;
				case 'addToFav':
					self.addToFav(glassID)
					break;
				case 'quickSave':
					self.quickSave(glassID)
					break;
				default:
			}
		}, 1000);
	}

	dispatchSelectGlass(glassID) {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedGlass: glassID
			}
		})
  	}

  	addToCart(glassID) {
  		const {framedCalc, frameSizeW, frameSizeH} = this.props;
		whichClicked = 'addToCart'
  		if (checkFramedSize(framedCalc, frameSizeW, frameSizeH, glassID)) {
	  		this.handleShow();
	  	} else {
	  		// Update QTY
	  		this.props.dispatch({
				type: 'SET_STATE',
				state: {
					cartQty: parseFloat(this.props.qty) + parseFloat(this.props.cartQty),
					customizeQTY: parseFloat(this.props.qty)
				}
			});
			var self = this;
	  		self.setState({cartLoading: true});
			const {cart1ItemTotal} = this.props;
	  		// Add to cart
	  		setTimeout(() => {
				$.ajax(ajaxurl, {
					method: "POST",
					dataType: 'json',
					data: $('.cartForm').serialize()+'&action=add_item_to_cart&cartTotal='+cart1ItemTotal,
					success: function (res) {
						self.setState({cartContent: res.message, cartShow: true, cartLoading: false});
						ReactPixel.track( 'AddToCart' );
					}
				});
			}, 1000);
		}
  	}

  	addToFav(glassID) {
		const {framedCalc, frameSizeW, frameSizeH} = this.props;
		whichClicked = 'addToFav'
  		if (checkFramedSize(framedCalc, frameSizeW, frameSizeH, glassID)) {
	  		this.handleShow();
	  	} else {
	  		var self = this;
	  		self.setState({favLoading: true});
			const {cart1ItemTotal} = this.props;
			setTimeout(() => {
		  		$.ajax(ajaxurl, {
					method: "POST",
					data: $('.cartForm').serialize()+'&action=is_user_logged_in&cartTotal='+cart1ItemTotal,
					success: function (res) {
						self.setState({addFav: res, lgShow: true, favLoading: false});
					}
				});
			}, 1000);
		}
	}

  	quickSave(glassID) {
		const {framedCalc, frameSizeW, frameSizeH} = this.props;
		whichClicked = 'quickSave'
  		if (checkFramedSize(framedCalc, frameSizeW, frameSizeH, glassID)) {
	  		this.handleShow();
	  	} else {
	  		setTimeout(() => {
		  		var res = true;
				const {savedItems} = this.state;
				const {selectedFrame, selectedTopMat, selectedMiddleMat, selectedBottomMat, topMatTotal, middleMatTotal, bottomMatTotal, frameTotal, glassTotal, selectedGlassName, selectedGlass, backingTotal, selectedBackingName, selectedBacking, printTotal, selectedPrintName, selectedPrint, cart1ItemTotal, selectedMatSize, selectedTopMatValueInCM, selectedMiddleMatValueInCM, selectedBottomMatValueInCM, frameImageWidth, frameImageHeight, canvasImage, canvasThumbImage, qty, frameSizeH, frameSizeW} = this.props;
				if (savedItems.length > 0) {
			  		savedItems.forEach(item => {
			  			if ( parseFloat(selectedFrame.get('id')) !== parseFloat(item.selectedFrame.get('id')) || selectedTopMat !== item.selectedTopMat || selectedMiddleMat !== item.selectedMiddleMat || selectedBottomMat !== item.selectedBottomMat || selectedGlass !== item.selectedGlass || selectedBacking !== item.selectedBacking || selectedPrint !== item.selectedPrint || selectedMatSize !== item.selectedMatSize ) {
					        res = true
					    } else {
					    	res = false
					    }
					});
		  		}
				if ( res === true ) {
					savedItems.push({
			            selectedFrame,
			            frameTotal,
			            frameSizeH,
			            frameSizeW,
			            selectedTopMat,
			            selectedMiddleMat,
			            selectedBottomMat,
			            selectedTopMatValueInCM,
			            selectedMiddleMatValueInCM,
			            selectedBottomMatValueInCM,
			            topMatTotal,
			            middleMatTotal,
			            bottomMatTotal,
			            selectedMatSize,
			            selectedGlass,
			            glassTotal,
			            selectedGlassName,
			            selectedBacking,
			            backingTotal,
			            selectedBackingName,
			            selectedPrint,
			            printTotal,
			            selectedPrintName,
			            cart1ItemTotal,
			            canvasImage,
			            canvasThumbImage,
			            frameImageHeight,
			            frameImageWidth,
			            qty
			        });
			        this.setState({ savedItems })
				}
			}, 1000);
		}
  	}

  	deleteArray = (array) => {
		var arrayFinal = this.state.savedItems.filter(function(item, key) {
			return key !== parseFloat(array)
		});
		this.setState({ savedItems: arrayFinal })
		this.manageView(arrayFinal);
  	}

  	manageView = (array) => {
  		const {compare1Selection, compare2Selection} = this.state;
  		if (array.length <= parseFloat(compare1Selection)) {
  			this.setState({ compare1Selection: array.length - 1 })
  		}
		if (array.length <= parseFloat(compare2Selection)) {
  			this.setState({ compare2Selection: array.length - 1 })
  		}
  	}

  	editSaved = (array) => {
  		const {savedItems} = this.state;
  		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedFrame: savedItems[array].selectedFrame,
				selectedTopMat: savedItems[array].selectedTopMat,
				selectedMiddleMat: savedItems[array].selectedMiddleMat,
				selectedBottomMat: savedItems[array].selectedBottomMat,
				selectedTopMatValueInCM: savedItems[array].selectedTopMatValueInCM,
				selectedMiddleMatValueInCM: savedItems[array].selectedMiddleMatValueInCM,
				selectedBottomMatValueInCM: savedItems[array].selectedBottomMatValueInCM,
				topMatTotal: savedItems[array].topMatTotal,
				middleMatTotal: savedItems[array].middleMatTotal,
				bottomMatTotal: savedItems[array].bottomMatTotal,
				selectedMatSize: savedItems[array].selectedMatSize,
				selectedGlass: savedItems[array].selectedGlass,
				glassTotal: savedItems[array].glassTotal,
				selectedGlassName: savedItems[array].selectedGlassName,
				selectedBacking: savedItems[array].selectedBacking,
				backingTotal: savedItems[array].backingTotal,
				selectedBackingName: savedItems[array].selectedBackingName,
				selectedPrint: savedItems[array].selectedPrint,
				printTotal: savedItems[array].printTotal,
				selectedPrintName: savedItems[array].selectedPrintName,
				cart1ItemTotal: savedItems[array].cart1ItemTotal,
				canvasImage: savedItems[array].canvasImage,
				frameImageWidth: savedItems[array].frameImageWidth,
				frameImageHeight: savedItems[array].frameImageHeight,
				qty: savedItems[array].qty,
				frameTotal: savedItems[array].frameTotal,
				frameSizeH: savedItems[array].frameSizeH,
	            frameSizeW: savedItems[array].frameSizeW
			}
		})
		this.setState({ show: false })
  	}

	handleChange1(event) {
    	this.setState({ compare1Selection: event.target.value });
  	}

  	handleChange2(event) {
    	this.setState({ compare2Selection: event.target.value });
  	}

	render() {
		const {savedItems, compare1Selection, compare2Selection, cartLoading, cartShow, cartContent, favLoading, lgShow, addFav, showGlassPopup} = this.state;
		const {selectedFrame, selectedGlass, frameFullDimension, qty, imageSizeError} = this.props;
        const selectOptions = [];
       	for (let i = 0; i < savedItems.length; i++) {
	        selectOptions.push(<option key={i} value={i}>{i+1}</option>);
		}

	    return (
			<div>
				{imageSizeError || qty === '' ?
					<div className='alert alert-danger m-b-5 p-b-9 p-t-9'>Please correct the errors and try again!</div> :
					<div>
						<Modal
							show={showGlassPopup}
							onHide={this.handleClose}
						>
							<Modal.Header closeButton>
					        	<Modal.Title id="contained-modal-title-lg">Change Required</Modal.Title>
					        </Modal.Header>
							<Modal.Body>
								<p>Unfortunately the Picture Frame size you have selected requires you to select the Perspex Glass option. We highly recommend Perspex Glass for this Picture Frame size, as it is much lighter than Standard Glass and is much safer, as Perspex Glass will not break. If you have any questions please contact us today!</p>
							</Modal.Body>
							<Modal.Footer>
								<Button className="btn btn-primary btn-danger" onClick={this.handleClose}>Cancel</Button>
								<Button className="btn btn-primary btn-default" onClick={this.handleOkay}>That's OK</Button>
							</Modal.Footer>
						</Modal>
						{frameFullDimension < 40 ?
							<div className='alert alert-danger m-b-5 p-b-9 p-t-9'>Framed Size must be atleast 40 to proceed!</div> :
							<div className="cont_rgt_btn">
								{selectedFrame.size > 0 ?
									<ul>
										<li className="m-b-5">
											<CartForm
												{...this.props}
												btnText='Buy it now' />
										</li>
										<li className="m-b-5">
											<a href="#!" className="btn btn-primary default-btn single_add_to_cart_button" onClick={this.addToCart.bind(this, selectedGlass)}>
												{cartLoading ?
													<div className="loading"></div> :
													<span>Add to cart</span>
												}
											</a>
											<GetCartPopOver
												cartShow={cartShow}
												cartHide={this.cartHide}
												cartContent={cartContent} />
										</li>
										<li className="m-b-5">
											<a href="#!" className="btn btn-primary default-btn" onClick={this.quickSave.bind(this, selectedGlass)}>Quick save</a>
										</li>
										<li className="m-b-5">
											<a href="#!" className="btn btn-primary default-btn" onClick={this.addToFav.bind(this, selectedGlass)}>
												{favLoading ?
													<div className="loading"></div> :
													<i className="far fa-heart"></i>
												}
											</a>
											<GetFavModal
												lgShow={lgShow}
												lgClose={this.lgClose}
												addFav={addFav} />
										</li>
									</ul>
									:
									<div className="loadingSecButton">
										<Loader />
									</div>
								}
							</div>
						}
					</div>
				}
				<div className="cont_rgt_saved">
					<p>Saved: {savedItems.length > 0 ? savedItems.length : 0 }</p>
					<a href="#!" onClick={() => this.setState({ show: true })}>View/Compare</a>
					<Modal
						show={this.state.show}
						onHide={this.lgHide}
						bsSize="large"
					>
						<Modal.Header closeButton>
				        	<Modal.Title id="contained-modal-title-lg">View Compare</Modal.Title>
				        </Modal.Header>
				        {savedItems.length <= 1 ?
				        	<Modal.Body>
								<div className="alert alert-danger">Please quick save atleast two items to compare!</div>
							</Modal.Body>
				        	:
				        	<Modal.Body>
								<div className="row view-compare-outer">
									<div className="col-sm-6">
										<select className="col-sm-12" value={compare1Selection} onChange={this.handleChange1}>
								        	{selectOptions}
								        </select>
								        <SavedItems
								        	{...this.props}
								        	savedItems={savedItems}
								        	deleteArray={this.deleteArray}
								        	editSaved={this.editSaved}
								        	viewArray={compare1Selection} />
									</div>
									<div className="col-sm-6">
										<select className="col-sm-12" value={compare2Selection} onChange={this.handleChange2}>
								        	{selectOptions}
								        </select>
								        <SavedItems
								        	{...this.props}
								        	savedItems={savedItems}
								        	deleteArray={this.deleteArray}
								        	editSaved={this.editSaved}
								        	viewArray={compare2Selection} />
									</div>
								</div>
							</Modal.Body>
				        }
					</Modal>
				</div>
			</div>
	    );
	}
}

class GetCartPopOver extends Component {
	render() {
		return (
			<Modal
				show={this.props.cartShow}
				onHide={this.props.cartHide}
			>
				<Modal.Header closeButton>
		        	<Modal.Title id="contained-modal-title-lg">Cart</Modal.Title>
		        </Modal.Header>
				<Modal.Body>
					{this.props.cartContent !== null ? Parser(this.props.cartContent) : ''}
				</Modal.Body>
			</Modal>
		)
	}
}

class GetFavModal extends Component {
	render() {
		return (
			<Modal
				show={this.props.lgShow}
				onHide={this.props.lgClose}
			>
				<Modal.Header closeButton>
		        	<Modal.Title id="contained-modal-title-lg">Favourites</Modal.Title>
		        </Modal.Header>
				<Modal.Body>
					{this.props.addFav !== null ? Parser(this.props.addFav) : ''}
				</Modal.Body>
			</Modal>
		)
	}
}